import { render, staticRenderFns } from "./RoadmapItem.vue?vue&type=template&id=7c23b500&"
import script from "./RoadmapItem.vue?vue&type=script&lang=js&"
export * from "./RoadmapItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports